import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class OperatorReferenceService extends BaseReferenceService {
  constructor() {
    super('OperatorReference');
  }
}
